<template>
  <div class="diagrams-dialog">
    <el-dialog ref="pdfDialog"
               :visible.sync="showDialog"
               :title="$t('diagramDialog.AddPlanFromPDF')"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :append-to-body="true"
               custom-class="window"
               :width="dialogWidth+'px'"
               top="5vh"
               :show-close="false">
      <addPlanFromPdf ref="addPdfComponent"
                      @checkPageListChange='checkPageListChange'></addPlanFromPdf>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="closeDialog(false)">{{$t('diagramDialog.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   @click="save()"
                   :disabled="disabled">{{$t('diagramDialog.Save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile, newPdfPlanUrlPages, saveObjectActivities } from '@/api/config'
import addPlanFromPdf from '@/components/diagrams/addPlanFromPdf.vue'
import { uuid } from 'vue-uuid'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    openFrom: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dialogWidth: 1200,
      pdfDivHeight: 490,
      checkPageList: [],
      loading: false,
      saveLoading: null,
      activityList: []
    }
  },
  computed: {
    ...mapState(['jobsiteID']),
    disabled () {
      return this.checkPageList.length === 0
    }
  },
  created () {
  },
  mounted () {
    this.setDialogWidth()
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.currentFile = null
        this.checkPageList = []
        this.$nextTick(() => {
          this.$refs.addPdfComponent.clearPdf()
          // document.querySelector('.el-upload__input').click()
          this.setDialogWidth()
        })
      }
    }
  },
  methods: {
    checkPageListChange (data) {
      this.checkPageList = data
    },
    setDialogWidth () {
      var val = document.body.clientWidth
      if (val < 968) {
        this.dialogWidth = val
      } else {
        this.dialogWidth = 968
      }
      this.setPdfDivHeight()
    },
    setPdfDivHeight () {
      if (this.dialogWidth >= 1100) {
        let dialogHeight = document.body.clientHeight - 185
        if (dialogHeight < 400) {
          dialogHeight = 400
        }
        this.pdfDivHeight = dialogHeight
      } else {
        let dialogHeight = this.$refs.pdfDialog ? this.$refs.pdfDialog.$el.clientHeight : 0
        if (dialogHeight < 685) {
          dialogHeight = 685
        }
        if (dialogHeight > 0) {
          this.pdfDivHeight = (dialogHeight - 185)
        }
      }
      if (this.pdfDivHeight > 490) {
        this.pdfDivHeight = 490
      }
    },
    addPlan (data, batchAcitityId, count) {
      let that = this
      return new Promise((resolve, reject) => {
        newPdfPlanUrlPages(data, false).then(res => {
          res.forEach(ele => {
            that.activityList.push({
              JobsiteId: ele.JobsiteId,
              CorpId: ele.CorpId,
              ObjectId: ele.PlanId,
              PlanId: ele.PlanId,
              ActivityType: 9,
              CreatorId: ele.CreatorId,
              CreatedOn: ele.CreatedOn,
              CanNotify: !(batchAcitityId && batchAcitityId.length > 0),
              BatchActivityId: batchAcitityId,
              Module: 4
            })
          })
          resolve(count)
        }).catch((err) => {
          that.btnLoading = false
          that.saveLoading.close()
          reject(err)
        })
      })
    },
    getConfig (progressList, index) {
      let that = this
      return {
        onUploadProgress: function (progress) {
          progressList[index].loaded = Math.round(progress.loaded)
          progressList[index].total = Math.round(progress.total)
          let loaded = 0
          let total = 0
          for (let progress of progressList) {
            loaded += progress.loaded || 0
            total += progress.total || 0
          }
          let percent = that.$config.getFormatNumber(loaded * 100.0 / total) + '%'
          that.saveLoading.text = that.$t('upload.Uploading') + ' ' + that.$config.formatBytes(loaded) + '/' + that.$config.formatBytes(total) + ' ' + percent
          if (percent === '100%') {
            that.saveLoading.text = that.$t('upload.Waiting')
          }
        }
      }
    },
    save () {
      let that = this
      that.saveLoading = this.$loading({
        lock: true,
        text: this.$t('upload.Uploading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let totalPlansCount = 0
      let progressList = []
      let jobsiteId = that.jobsiteID
      for (let checkedPdf of this.checkPageList) {
        progressList.push({ index: checkedPdf.index })
        totalPlansCount += checkedPdf.pages.length
      }
      let time = 0
      let uploadArray = []
      let uploadPromises = []
      for (let checkedPdf of this.checkPageList) {
        let fileData = new FormData()
        fileData.append('JobsiteId', jobsiteId)
        fileData.append('file', checkedPdf.file.raw)
        let config = that.getConfig(progressList, checkedPdf.index)
        let uploadPromise = uploadFile(fileData, config).then(async result => {
          let name = checkedPdf.file.name
          let index = name.lastIndexOf('.')
          let fileName = index > 0 ? name.substring(0, index) : name
          uploadArray.push({ index: checkedPdf.index, url: result.FileUrl, name: fileName })
        }).catch(err => {
          console.log(err)
          that.btnLoading = false
          that.saveLoading.close()
        })
        uploadPromises.push(uploadPromise)
      }
      Promise.all(uploadPromises).then(async ppromiseGroupResult => {
        let batchAcitityId = totalPlansCount > 1 ? uuid.v4() : null
        for (let checkedPdf of this.checkPageList) {
          let uploadResult = uploadArray.find(q => q.index === checkedPdf.index)
          for (let selectPages of this.$config.splitGroupArray(checkedPdf.pages, 10)) {
            let data = {
              JobsiteId: jobsiteId,
              ProjectName: uploadResult.name,
              PdfUrl: uploadResult.url,
              Pages: selectPages
            }
            time += await that.addPlan(data, batchAcitityId, selectPages.length)
            that.saveLoading.text = that.$t('taskDialog.Saving') + '  total: ' + time + '/' + totalPlansCount
          }
        } if (totalPlansCount > 1) {
          that.activityList.push({
            JobsiteId: jobsiteId,
            ObjectId: '',
            ActivityType: 15,
            CanDisplay: false,
            Id: batchAcitityId,
            Module: 4
          })
        }
        that.saveObjectActivities()
        if (time === totalPlansCount) {
          that.saveLoading.close()
          that.closeDialog(true)
          that.$refs.addPdfComponent.clearPdf()
          if (that.openFrom === 'Project') {
            that.$router.push({
              name: 'diagrams'
            })
          }
        }
      })
    },
    closeDialog (needRefresh) {
      this.$emit('closeDialog', needRefresh)
    },
    saveObjectActivities () {
      saveObjectActivities(this.activityList).then(res => {

      })
    }
  },
  components: {
    addPlanFromPdf
  }
}
</script>
